module.exports = __webpack_public_path__ + "media/luxury-2026/modern-exterior-960-fc3542e2.jpg";